import { Box, Card, CardContent, CardHeader } from "@mui/material"
import { LineChart } from "@mui/x-charts/LineChart"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import { useState } from "react"
import Loading from "../../../components/Common/Loading"
import { useGetSessionsTOHQuery } from "../../../core/api/toh-analytical-data-api"

const formatTick = (value) => dayjs(value).format("DD.MM HH:mm")
const formatTooltip = (value) => dayjs(value).format("DD.MM.YYYY HH:mm:ss")

const pickerSlotProps = {
    textField: { size: "small" }
}

const GemEnergyBalanceTOH = (props) => {
    const [from, setFrom] = useState(() => dayjs().subtract(7, "day"))
    const [to, setTo] = useState(() => dayjs())

    const rangeValid = from?.isValid?.() && to?.isValid?.() && to.isAfter(from)

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetSessionsTOHQuery({
        userId: props.deviceId,
        from: from?.toISOString(),
        to: to?.toISOString()
    }, {
        skip: !props.deviceId || !rangeValid
    })

    let chart = "no data"

    if (Array.isArray(data)) {
        const points = data.filter((row) => row.timestamp && (row.gemBalance || row.energyBalance))
        const timestamps = points.map((row) => new Date(row.timestamp))
        const gem = points.map((row) => row.gemBalance)
        const energy = points.map((row) => row.energyBalance)

        if (timestamps.length > 0) {
            chart = (
                <LineChart
                    height={400}
                    xAxis={[{
                        data: timestamps,
                        scaleType: "time",
                        tickNumber: 16,
                        valueFormatter: (value, context) =>
                            context.location === "tick" ? formatTick(value) : formatTooltip(value)
                    }]}
                    series={[
                        { data: gem, label: "Gem", color: "red", connectNulls: true, showMark: false, strokeWidth: 1 },
                        { data: energy, label: "Energy", color: "blue", connectNulls: true, showMark: false, strokeWidth: 1 }
                    ]}
                />
            )
        }
    }

    return (
        <Card>
            <CardHeader
                title="Gem/Energy balance"
                action={
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box sx={{ display: "flex", gap: 1, pt: 1 }}>
                            <DateTimePicker
                                label="From"
                                value={from}
                                onChange={setFrom}
                                format="DD.MM.YYYY HH:mm"
                                ampm={false}
                                disableFuture
                                slotProps={pickerSlotProps}
                            />
                            <DateTimePicker
                                label="To"
                                value={to}
                                onChange={setTo}
                                format="DD.MM.YYYY HH:mm"
                                ampm={false}
                                disableFuture
                                slotProps={pickerSlotProps}
                            />
                        </Box>
                    </LocalizationProvider>
                }
            />
            <CardContent>
                <Loading
                    isLoading={isLoading || isFetching}
                    isError={isError}
                    error={error}
                    isSuccess={isSuccess || !rangeValid}
                >
                    {chart}
                </Loading>
            </CardContent>
        </Card>
    )
}

export default GemEnergyBalanceTOH
